import { defineComponent as c, useSlots as p, createElementBlock as d, openBlock as u, mergeProps as f, unref as o, createElementVNode as b, normalizeClass as _, createVNode as B } from "vue";
import t from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Breadcrumb/breadcrumb.js";
import { findChildrenVNodes as h } from "../../util.js";
import { useOUIAProps as P } from "../../helpers/ouia.js";
const v = ["aria-label"], S = /* @__PURE__ */ c({
  name: "PfBreadcrumb",
  __name: "Breadcrumb",
  props: {
    ariaLabel: { default: "Breadcrumb" },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(i) {
    const s = i, l = P({ id: s.ouiaId, safe: s.ouiaSafe }), a = p(), m = () => {
      var e;
      return h((e = a.default) == null ? void 0 : e.call(a, {})).map((r, n) => (r.props && (r.props.showDivider = n > 0), r));
    };
    return (e, r) => (u(), d("nav", f(o(l), {
      class: o(t).breadcrumb,
      "aria-label": e.ariaLabel
    }), [
      b("ol", {
        class: _(o(t).breadcrumbList)
      }, [
        B(m)
      ], 2)
    ], 16, v));
  }
});
export {
  S as default
};
